import React, { useContext, useEffect, useState } from 'react'
import { NavLink, useParams } from 'react-router-dom'
import { Empty, Layout, Menu } from 'antd'
import Sider from 'antd/es/layout/Sider'
import DynamicMenu from '../../modules/DynamicMenu/DynamicMenu'
import { Content } from 'antd/es/layout/layout'
import { WrapperData } from '../../style/style'
import WrapperTextPage from '../../modules/WrapperTextPage/WrapperTextPage'
import { getRequest } from '../../request/request'
import { trophyBookMenu } from '../TrophyBook/list'
import { errors } from '../../function/errors'
import { ContextType } from '../../type/type'
import { AppContext } from '../../App'
import { useTranslation } from 'react-i18next'
import ArchiveNews from '../News/ArchiveNews'
import BottomMenuInfo from '../../modules/BottomMenuInfo/BottomMenuInfo'
import { log } from 'util'

const WomansClub = () => {
  const { t } = useTranslation()
  const { type = '53' } = useParams()
  const { state, isMobileWidth } = useContext<ContextType>(AppContext)
  // const [menuActive, setMenuActive] = useState(false)
  const [dataMenu, setDataMenu] = useState<any[]>([])
  const [collapsed, setCollapsed] = useState(false)
  const [breakpoint, setBreakpoint] = useState(false)

  const trophyBookMenu = (t: any) => [
    {
      key: 'womans-news',
      label: <NavLink state={{ breadcrumbs: t('h216') }} to={`/womans-club/womans-news?type=17`}>{t('h170')}</NavLink>,
    },
  ]

  useEffect(() => {
    getRequest(`/pages/page/?category_id=${17}`)
      .then((res) => {
        const result = res?.data?.results
        const arr = result?.map((e: any) => ({
          key: e.id,
          label: <NavLink state={{ breadcrumbs: t('h216') }} to={`/womans-club/${e.id}?type=17`}>{e.title}</NavLink>,
        }))

        setDataMenu([...arr, ...trophyBookMenu(t)])
      })
      .catch((err) => {
        errors(err)
      })
  }, [state.lang])

  const handleCollapse = (collapsed: boolean, type: string) => {
    if (type === 'clickTrigger') setCollapsed(collapsed)
  }

  const handleClickMenu = () => {
    if (breakpoint) setCollapsed(true)
  }

  return (
    <Layout className="br-12">
      { isMobileWidth ? 
        <Menu className="w-240" selectedKeys={[type]} mode="inline" items={dataMenu} onClick={handleClickMenu} />
        :
        <Sider
          width={270}
          breakpoint="lg"
          collapsedWidth="0"
          className="site-layout-background"
          // collapsible
          collapsed={collapsed}
          onBreakpoint={(broken) => setBreakpoint(broken)}
          onCollapse={(collapsed: boolean, type: string) => handleCollapse(collapsed, type)}
        >
          <Menu className="w-240" selectedKeys={[type]} mode="inline" items={dataMenu} onClick={handleClickMenu} />
          <BottomMenuInfo type="woman" />
        </Sider>
      }
      <Content>
        <WrapperData>
          {type === 'womans-news' ? <ArchiveNews type="woman" /> : <WrapperTextPage id={type} />}
        </WrapperData>
      </Content>
      {
     isMobileWidth && <BottomMenuInfo type="woman"/>
      }
 
    </Layout>
  )
}
export default WomansClub
